import React, { useEffect, useState } from "react";
import "./eligibility-flow.scss";
import ProgressBar from "../../../components/progressBar/ProgressBar";
import AppointmentDateTime, {
  showAppointmentsForPaths,
} from "./AppointmentDateTime";

const EligibilityFlowHeader = ({ percentage, step, currentPath }) => {
  let [actualPercentage, setActualPercentage] = useState(percentage);

  const showButtonsForPaths = [
    "",
    "callback",
    "condition",
    "age",
    "eligibility-success",
    "eligibility-error",
    "eligibility-age-error",
  ];

  const showAppointmentDateTime =
    showAppointmentsForPaths.includes(currentPath);

  useEffect(() => {
    setActualPercentage(percentage);

    const scrollPosition = window.scrollY;

    window.history.scrollRestoration = "manual";
    window.scrollTo(0, scrollPosition);

    return () => {
      window.history.scrollRestoration = "auto";
    };
  }, [percentage]);

  return (
    <div className="container">
      <div className="column">
        <div className="d-flex flex-row gap-2 align-items-center justify-content-between mt-3">
          <div className="d-none d-md-block">
            <AppointmentDateTime
              currentPath={currentPath}
              className="border rounded"
            />
          </div>
          {showButtonsForPaths.includes(currentPath) && (
            <div className="d-none d-md-block">
              <div className="d-flex flex-row align-items-center">
                <a
                  href="https://treat-it.clinic/conditions/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-0 bg-transparent text-black fw-bold me-2 me-xl-4 text-decoration-none"
                >
                  {" "}
                  Conditions
                </a>
                <a
                  href="https://treat-it.clinic/pricing/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-0 bg-transparent text-black fw-bold text-decoration-none"
                >
                  {" "}
                  Pricing
                </a>
              </div>
            </div>
          )}
        </div>
        <div
          className={`col-11 col-md-5 ${
            showAppointmentDateTime ? "mt-12" : "mt-7"
          } mt-md-8 align-items-center justify-content-between`}
        >
          <p className="fw-bold mb-0">{step}</p>
          <div className="d-flex flex-row align-items-center">
            <div className="w-100 py-2">
              <ProgressBar
                progressPercentage={actualPercentage}
                className="w-100 w-md-50"
              />
            </div>

            {actualPercentage === 100 &&
              currentPath !== "callback" &&
              currentPath !== "eligibility-error" && 
              currentPath !== "eligibility-age-error" && (
                <img
                  src="/images/eligibility/confetti.png"
                  alt="success"
                  className="progress-img"
                />
              )}

            {currentPath === "eligibility-error" || currentPath === "eligibility-age-error" && (
              <img
                src="/images/eligibility/crying-emoji.svg"
                alt="success"
                className="progress-img"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EligibilityFlowHeader;
